import React from 'react'

export default function Ender() {
    return (
        <div id= 'main3'>
            <div className='header-heading'>

    
            <h1> <span>DA</span>DA<br/>SHI</h1>
           

     

            
            </div>

        </div>
    )
}
